module.exports = vendor1_4ac1ebba;